import axios from "axios";

import configOptions from "../config";

const ApiClient = axios.create({
    baseURL: configOptions.apiEndpoint,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
    withCredentials: true,
});

ApiClient.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});

export default ApiClient;